import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import "../App.css";
import "../App.tailwind.css";
import { useNavigate } from "react-router-dom";
import useAuth from "../tools/useAuth";
function ConnectionPage() {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (isAuthenticated) {
            navigate("/SessionsPage");
        }
    }, [isAuthenticated, navigate]);
    function handleLogin() {
        window.location.href = "/auth/login?returnTo=/SessionsPage";
    }
    return (_jsxs("div", Object.assign({ className: "w-screen h-full flex justify-center", style: { opacity: "1" } }, { children: [_jsx("div", { className: "flex absolute bg-dilemmeDeepPurpple w-full h-full", style: { opacity: "0.8" } }), _jsx("div", Object.assign({ className: "flex absolute w-full h-full justify-center" }, { children: _jsxs("div", Object.assign({ className: "flex relative flex-col bg-white justify-center items-center", style: {
                        width: "424px",
                        height: "200px",
                        top: "25%",
                        padding: "32px",
                        border: "2px solid #000000",
                    } }, { children: [_jsx("div", Object.assign({ className: "flex relative justify-center text-dilemmeDeepPurpple font-roboto text-center", style: {
                                width: "100%",
                                marginBottom: "24px",
                                fontSize: "18px",
                                fontWeight: "700",
                            } }, { children: "CONNEXION" })), _jsx("button", Object.assign({ onClick: handleLogin, className: "flex relative self-center bg-dilemmeDeepPurpple text-white font-roboto justify-center text-center items-center hover:bg-white hover:text-dilemmeDeepPurpple hover:border-dilemmeDeepPurpple", style: {
                                width: "84.67%",
                                height: "50px",
                                fontSize: "14px",
                                fontWeight: "900",
                                lineHeight: "14px",
                                textTransform: "uppercase",
                                border: "2px solid #000000",
                            } }, { children: "SE CONNECTER" }))] })) }))] })));
}
export default ConnectionPage;
